import { usePageHeader } from '@/Components/AppHeader/AppHeader';
import { PageType } from '@/Components/HeroBanner';
import DetailsHero from '@/Components/HeroBanner/DetailsHero';
import ShowHeroBanner from '@/Components/HeroBanner/ShowHeroBanner';
import ErrorMessage from '@/Components/Message';
import RailWrapper from '@/Components/Rail/RailWrapper';
import Synopsis from '@/Components/Synopsis';
import synopsisStyles from '@/Components/Synopsis/styles.module.scss';
import useOfferDetails from '@/Hooks/PUJ/useOfferDetail';
import usePackageDetails from '@/Hooks/PUJ/usePackageDetail';
import useIsNewHistory from '@/Hooks/useIsNewHistory';
import useMedia from '@/Hooks/useMedia';
import Content from '@/Layouts/containers/Content';
import Preloader from '@/Layouts/containers/Preloader';
import NotFound from '@/Pages/NotFound';
import { withTransaction } from '@elastic/apm-rum-react';
import { ImageAssetType } from '@skytvnz/sky-app-store/lib/types/enums';
import React, { useRef } from 'react';
import { useLocation, useParams } from 'react-router';
import usePinValidationModal from '@/Components/Modal/usePinValidationModal';
import { Show } from '@skytvnz/sky-app-store/lib/types/graph-ql';
import { CustomerPackageOffer } from '@/lib/graph-ql';
import styles from './styles.module.scss';

export interface StateType {
  pageName: string;
  sectionId: string;
}
export interface Params {
  offerId: string;
}

const Package: React.FC = () => {
  const { offerId } = useParams<Params>();
  const isNewHistory = useIsNewHistory();
  const location = useLocation();
  const { data, error, loading } = useOfferDetails(offerId);
  const { isMediaM } = useMedia();
  const { openPinModal } = usePinValidationModal();

  const offerDetail = data?.experience?.customer?.offer as CustomerPackageOffer;

  const synopsis = offerDetail?.synopsis;

  const image = offerDetail?.heroImage?.uri;
  const rails = offerDetail?.groupsPage?.groups;
  const basePrice = offerDetail?.price?.basePrice?.amount;
  const packageTitle = offerDetail?.title;
  const collectionId = offerDetail?.collectionLink?.collection.id;
  const collectionTitle = offerDetail?.collectionLink?.collection.title;
  const { offerText, discountPrice, hintMessage, actualPrice } = usePackageDetails(
    offerDetail,
    false,
    true,
  );
  const packageDetails = {
    isPackageDetailPage: true,
    packagePrice: basePrice,
    packageTitle,
    discountPrice,
    offerText,
    offerId,
    hintMessage,
    collectionId,
    collectionTitle,
    actualPrice,
  };
  const LastPaginatedRail = useRef({ id: '', index: 0 });
  usePageHeader({
    title: packageTitle && `Get ${packageTitle}`,
  });
  if (loading) return <Preloader isLoading />;
  if (!offerDetail) return <NotFound />;
  if (error || !data) return <ErrorMessage />;
  return (
    <>
      <ShowHeroBanner
        indexOnPage={1}
        className={styles.heroBanner}
        show={{} as Show}
        image={image}
        imageType={ImageAssetType.HeroLandingWide}
        pageType={PageType.Detail}
        packageDetails={packageDetails}
        origin={location?.state?.origin}
        offerDetails={offerDetail}
        openPinModal={openPinModal}
      />
      {!isMediaM && (
        <Content className={synopsisStyles.synopsis}>
          <Synopsis synopsis={synopsis} />
          <DetailsHero
            brand={{} as Show}
            isHome={false}
            packageDetails={packageDetails}
            origin={location?.state?.origin}
            openPinModal={openPinModal}
            hasPkgUpgrade // this enables the package upgrade button in package details page
          />
        </Content>
      )}

      <RailWrapper
        indexOnPage={2}
        rails={rails}
        LastPaginatedRail={LastPaginatedRail}
        isNewHistory={isNewHistory}
      />
    </>
  );
};

export default withTransaction('ShowDetail', 'component')(Package);
